export function objectToFormData(
  object: any,
  form?: FormData,
  namespace = '',
  isArray = false
): FormData {
  const formData = form || new FormData();

  for (const property in object) {
    if (
      // if the object[property] value is falsy except for boolean and null then we skip it
      !Object.prototype.hasOwnProperty.call(object, property) ||
      object[property] === undefined
    )
      continue;

    const formKey = namespace
      ? isArray
        ? `${namespace}${property}`
        : `${namespace}.${property}`
      : property;

    if (object[property] === null) {
      // https://stackoverflow.com/questions/62303002/angular-9-formdata-appendkey-null-actually-appends-null-string
      // only way to send null in formdata is to send empty string
      formData.append(formKey, '');
    }
    if (object[property] instanceof Date)
      // handle Dates
      formData.append(formKey, object[property].toISOString());
    else if (object[property] instanceof Array) {
      // handle Arrays
      object[property].forEach((element: any, index: any) => {
        const tempFormKey = `${formKey}[${index}]`;
        objectToFormData(element, formData, tempFormKey, true);
      });
    } else if (object[property] instanceof File) {
      // Handle Files
      formData.append(formKey, object[property], object[property].name);
    } else if (typeof object[property] === 'object') {
      // Handle Generic Objects
      objectToFormData(object[property], formData, formKey);
    } else {
      formData.append(formKey, object[property].toString());
    }
  }
  return formData;
}
